import React, { type FC, memo, useEffect } from 'react';
import { useForm, FormProvider } from 'FrontRoyalReactHookForm';
import { Textarea } from 'Textarea';
import { type FreeResponseFrameViewModel } from './FreeResponseFrameViewModel';
import { type FreeResponseFrame } from './FreeResponseFrame';

interface Props {
    frameViewModel: FreeResponseFrameViewModel;
}

interface FormData {
    prompt_instructions: string;
}

const FreeResponseEditorComponent: FC<Props> = ({ frameViewModel }) => {
    const frame = frameViewModel.frame as FreeResponseFrame;

    const form = useForm<FormData>({
        defaultValues: {
            prompt_instructions: frame.promptInstructions || '',
        },
    });

    const { watch } = form;
    const promptInstructions = watch('prompt_instructions');

    // Update frame data when form changes
    useEffect(() => {
        frame.promptInstructions = promptInstructions || '';
    }, [promptInstructions, frame]);

    return (
        <FormProvider {...form}>
            <div style={{ padding: '16px', borderRadius: '4px' }}>
                <Textarea
                    name="prompt_instructions"
                    label="AI Tutor instructions"
                    placeholder="Enter custom instructions for the AI Tutor..."
                    minRows={4}
                />
                <div style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
                    These instructions will be provided to the AI Tutor when responding to student questions.
                </div>
            </div>
        </FormProvider>
    );
};

export const FreeResponseEditor = memo(FreeResponseEditorComponent) as typeof FreeResponseEditorComponent;
